import type { SvgPath } from '../types';

/**
 * Some of the paths are taken from WordPress Dashicons Component
 * @link https://github.com/WordPress/gutenberg
 */
export const svgPath: SvgPath = {
	calculator:
		'M 3 0 v20 h14 v-20 h-14 z m 2.5 2.5 h9 v2 h-9 ' +
		'v-2 z m 0 4 h2 v1.75 h-2 v-1.75 z m 3.5 0 h2 v1.75 h-2 v-1.75' +
		' z m 3.5 0 h2 v1.75 h-2 v-1.75 z M 5.5 9.5 h2 v1.75 h-2 v-1.75' +
		' z m 3.5 0 h2 v1.75 h-2 v-1.75 z m 3.5 0 h2 v1.75 h-2 v-1.75 z M' +
		' 5.5 12.5 h2 v1.75 h-2 v-1.75 z m 3.5 0 h2 v1.75 h-2 v-1.75 z m' +
		' 3.5 0 h2 v1.75 h-2 v-1.75 z M 5.5 15.5 h2 v1.75 h-2 v-1.75 z m' +
		' 3.5 0 h2 v1.75 h-2 v-1.75 z m 3.5 0 h2 v1.75 h-2 v-1.75 z ',
	calendar:
		'M 0 2 v18 h20 v-18 z ' +
		'M 2 6.5 h16 v11.5 h-16 z ' +
		'M 15.5 0 V8 h-1.38 L11.54 10.06 l .8 1.2 .92 -.74 c .12' +
		' -.1 .32 -.28 .6 -.56 l -.04 .84 V16.5 H15.5 z ' +
		'M 9.5 10 ' +
		'c 0 -.6 -.24 -1.08 -.74 -1.42 -.48 -.34 -1.16 -.52 -2' +
		' -.52 -1.04 0 -1.92 .26 -2.66 .8 ' +
		'l .8 1.2  ' +
		'c .34 -.22 .64 -.38 .92 -.46 .28 -.1 .54 -.14 .82 -.14' +
		' .76 0 1.16 .3 1.16 .92 0 .4 -.14 .7 -.44 .86  ' +
		's -.76 .24 -1.4 .24 ' +
		'h -.62 ' +
		'v 1.32 ' +
		'h .62 ' +
		'c .68 0 1.18 .08 1.5 .24 .3 .16 .46 .44 .46 .82 0 .44' +
		' -.14 .74 -.4 .94 -.28 .2 -.7 .3 -1.26 .3 -.38 0 -.76' +
		' -.06 -1.14 -.16 ' +
		's -.72 -.24 -1.04 -.4 ' +
		'v 1.48 ' +
		'c .68 .3 1.48 .44 2.36 .44 1.06 0 1.88 -.22 2.44 -.66' +
		' .58 -.44 .86 -1.04 .86 -1.84 0 -.54 -.18 -.96 -.52 -1.28 ' +
		's -.84 -.52 -1.48 -.6 ' +
		'v -.04 ' +
		'c .54 -.12 .98 -.38 1.3 -.74 .3 -.36 .46 -.78 .46 -1.3 z ' +
		'M 4 0 h2 v2 h-2 v-2 z ' +
		'M 14 0 h2 v2 h-2 v-2 z',
	edit:
		'M13.89 3.39l2.71 2.72c.46.46.42 1.24.03 1.64l-8.01 ' +
		'8.02-5.56 1.16 1.16-5.58s7.6-7.63 7.99-8.03c.39-.39 ' +
		'1.22-.39 1.68.07zm-2.73 2.79l-5.59 5.61 1.11 1.11 ' +
		'5.54-5.65zm-2.97 8.23l5.58-5.6-1.07-1.08-5.59 5.6z',
	filter: 'M3 4.5v-2s3.34-1 7-1 7 1 7 1v2l-5 7.03v6.97s-1.22-.09-2.25-.59S8 16.5 8 16.5v-4.97z',
	groups: 'M8.030 4.46c-0.29 1.28 0.55 3.46 1.97 3.46 1.41 0 2.25-2.18 1.96-3.46-0.22-0.98-1.080-1.63-1.96-1.63-0.89 0-1.74 0.65-1.97 1.63zM3.9 5.36c-0.25 1.080 0.47 2.93 1.67 2.93s1.92-1.85 1.67-2.93c-0.19-0.83-0.92-1.39-1.67-1.39s-1.48 0.56-1.67 1.39zM12.76 5.36c-0.25 1.080 0.47 2.93 1.66 2.93 1.2 0 1.92-1.85 1.67-2.93-0.19-0.83-0.92-1.39-1.67-1.39-0.74 0-1.47 0.56-1.66 1.39zM12.17 16.79l1.25-4.3c0.78-2.49-0.71-4.020-3.42-4.020-2.72 0-4.21 1.53-3.44 4.020l1.26 4.3c0.23 0.72 1.18 1.21 2.18 1.21 0.98 0 1.94-0.49 2.17-1.21zM6.070 9.16c-0.49 0.67-0.96 1.83-0.42 3.59l1.12 3.79c-0.34 0.2-0.77 0.31-1.2 0.31-0.85 0-1.65-0.41-1.85-1.030l-1.070-3.65c-0.65-2.11 0.61-3.4 2.92-3.4 0.27 0 0.54 0.020 0.79 0.060-0.1 0.1-0.2 0.22-0.29 0.33zM14.42 8.77c2.31 0 3.58 1.29 2.92 3.4l-1.070 3.65c-0.2 0.62-1 1.030-1.85 1.030-0.43 0-0.86-0.11-1.2-0.31l1.11-3.77c0.55-1.78 0.080-2.94-0.42-3.61-0.080-0.11-0.18-0.23-0.28-0.33 0.25-0.040 0.51-0.060 0.79-0.060z',
	'ticket-alt':
		'M20 6.38L18.99 9.2v-.01c-.52-.19-1.03-.16-' +
		'1.53.08s-.85.62-1.04 1.14-.16 1.03.07 1.53c.24.5.62.84 1.15 ' +
		'1.03v.01l-1.01 2.82-15.06-5.38.99-2.79c.52.19 1.03.16 ' +
		'1.53-.08.5-.23.84-.61 1.03-1.13s.16-1.03-.08-1.53c-' +
		'.23-.49-.61-.83-1.13-1.02L4.93 1zm-4.97 ' +
		'5.69l1.37-3.76c.12-.31.1-.65-.04-.95s-.39-.53-.7-.65L8.14 ' +
		'3.98c-.64-.23-1.37.12-1.6.74L5.17 8.48c-.24.65.1 1.37.74 ' +
		'1.6l7.52 2.74c.14.05.28.08.43.08.52 0 1-.33 1.17-.83zM7.97 ' +
		'4.45l7.51 2.73c.19.07.34.21.43.39.08.18.09.38.02.57l-1.37 ' +
		'3.76c-.13.38-.58.59-.96.45L6.09 ' +
		'9.61c-.39-.14-.59-.57-.45-.96l1.37-3.76c.1-.29.39-.49.7-.49.09 0 ' +
		'.17.02.26.05zm6.82 12.14c.35.27.75.41 1.2.41H16v3H0v-2.96c.55 0 ' +
		'1.03-.2 1.41-.59.39-.38.59-.86.59-1.41s-.2-1.02-.59-1.41-.86-.59' +
		'-1.41-.59V10h1.05l-.28.8 2.87 1.02c-.51.16-.89.62-.89 ' +
		'1.18v4c0 .69.56 1.25 1.25 1.25h8c.69 ' +
		'0 1.25-.56 1.25-1.25v-1.75l.83.3c.12.43.36.78.71 1.04zM3.25 ' +
		'17v-4c0-.41.34-.75.75-.75h.83l7.92 2.83V17c0 ' +
		'.41-.34.75-.75.75H4c-.41 0-.75-.34-.75-.75z',
};
